import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { logger } from '../logger';
export const ErrorLoggerBoundary = ({ children }) => (React.createElement(ErrorBoundary, { onError: (e) => {
        logger.error(e);
    }, fallbackRender: () => {
        return null;
    } }, children));
